module.exports = __webpack_public_path__ + "img/enjoy.e8a8e6c4.png";